module.exports = __webpack_public_path__ + "img/penguin.be5030ca.webp";